import React from "react";
import { useParams } from "react-router";
import { RefActivity } from "../../../api/hooks";
import ActivityView from "../../../common/activity/ActivityView";

const BranchActivity = () => {
    const { branchId } = useParams<any>();
    return (
        <div>
            {branchId && (
                <ActivityView
                    className="mt-3 border"
                    activityRef={RefActivity?.Branch}
                    activityRefId={branchId ?? ""}
                />
            )}
        </div>
    );
};

export default BranchActivity;
